<template>
  <div id="embed_video">
    <uep-player
      v-if="playerUrl.crypted"
      :url="playerUrl.crypted"
      :query="query"
      @readyPlayer="readyPlayer"
      @infoDetails="infoDetails"
    ></uep-player>
    <uep-player
      v-if="crypted"
      :url="crypted"
      :query="query"
      @readyPlayer="readyPlayer"
      @infoDetails="infoDetails"
    ></uep-player>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import ComponentVideo from '~/node_modules/component-video/src/components/Componentplay.vue';

  export default {
    name: 'embedVideo',
    metaInfo: {
      title: process.env.META_TITLA,
    },
    components: {
      ComponentVideo,
    },
    data() {
      return {
        player: {},
        info: {},
        autoplay: false,
        color: null,
      };
    },
    computed: {
      ...mapGetters({
        playerUrl: 'videos/getPlayerUrl',
        skinPlayer: 'layout/getCurrentSkinPlayer',
      }),
      query() {
        const pathname = this.$route.name;
        let idArray;

        if (pathname === 'video') {
          idArray = this.$route.params.videoId.split('-');
        } else {
          idArray = this.$route.params.playlistId.split('-');
        }

        let q = { skin: this.skinPlayer ? this.skinPlayer : 'dark' , videoStats: true, };
        if (idArray.length > 1) {
          q = {
            a: idArray[1],
            color: this.getColor(idArray[2]),
            x: idArray[3],
          };
        }
        return { ...q, ...this.$route.query };
      },
      crypted() {
        return this.playerUrl.link ? this.playerUrl.link.split('/').reverse()[0] : null;
      },
    },
    methods: {
      ...mapActions('videos', ['setCurrentVideo', 'getCryptedUrl', 'getCryptedPlaylistUrl']),
      readyPlayer(param) {
        var self = this;
        this.player = param;
        if (this.query.x) this.player.currentTime(this.query.x);
        this.player.on('error', function() {
          if (self.player.options_ && self.player.options_.sources[1]) self.player.src(self.player.options_.sources[1]);
        });

      },
      infoDetails(param) {
        this.info = param;
      },
      getEmbedVideo(pathname) {
        if (pathname === 'video') {
          const id = this.$route.params.videoId;
          this.getCryptedUrl(id);
        } else {
          const id = this.$route.params.playlistId;
          this.getCryptedPlaylistUrl(id);
        }
      },
      getColor(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
          ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`
          : null;
      },
    },
    created() {
      const pathname = this.$route.name;
      this.getEmbedVideo(pathname);
    },
    mounted() {
    },
  };
</script>

<style scoped lang="scss">
  @import '../assets/scss/_variables.scss';
  @import "../assets/scss/mix.scss";

  #embed_video {
    width: calc(100% + 30px);
    height: 100vh;
    overflow: hidden;
    margin: 0 -15px;

    /deep/ object.vjs-tech {
      height: 100% !important;
    }
  }

  #embed_video {
    /deep/ #uep_player_component {
      position: relative;

      .vjs-big-play-button {
        transition: none !important;
        display: block !important;
      }

      .vjs-playing .vjs-big-play-button {
        display: none !important;
      }

      .vjs-playlist {
        background-color: #dadada;

        &.vjs-playlist-vertical {
          .vjs-playlist-item {
            margin-bottom: 0;

            &:not(.vjs-selected):before {
              content: '';
              position: absolute;
              width: 100%;
              height: 100%;
              left: 0;
              top: 0;
              background-size: 40px;
              background-repeat: no-repeat;
              background-position: center;
              background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDMxNC4wNjggMzE0LjA2OCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzE0LjA2OCAzMTQuMDY4OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PGc+Cgk8ZyBpZD0iX3gzM181Ni5fUGxheSI+CgkJPGc+CgkJCTxwYXRoIGQ9Ik0yOTMuMDAyLDc4LjUzQzI0OS42NDYsMy40MzUsMTUzLjYxOC0yMi4yOTYsNzguNTI5LDIxLjA2OEMzLjQzNCw2NC40MTgtMjIuMjk4LDE2MC40NDIsMjEuMDY2LDIzNS41MzQgICAgIGM0My4zNSw3NS4wOTUsMTM5LjM3NSwxMDAuODMsMjE0LjQ2NSw1Ny40N0MzMTAuNjI3LDI0OS42MzksMzM2LjM3MSwxNTMuNjIsMjkzLjAwMiw3OC41M3ogTTIxOS44MzQsMjY1LjgwMSAgICAgYy02MC4wNjcsMzQuNjkyLTEzNi44OTQsMTQuMTA2LTE3MS41NzYtNDUuOTczQzEzLjU2OCwxNTkuNzYxLDM0LjE2MSw4Mi45MzUsOTQuMjMsNDguMjYgICAgIGM2MC4wNzEtMzQuNjksMTM2Ljg5NC0xNC4xMDYsMTcxLjU3OCw0NS45NzFDMzAwLjQ5MywxNTQuMzA3LDI3OS45MDYsMjMxLjExNywyMTkuODM0LDI2NS44MDF6IE0yMTMuNTU1LDE1MC42NTJsLTgyLjIxNC00Ny45NDkgICAgIGMtNy40OTItNC4zNzQtMTMuNTM1LTAuODc3LTEzLjQ5Myw3Ljc4OWwwLjQyMSw5NS4xNzRjMC4wMzgsOC42NjQsNi4xNTUsMTIuMTkxLDEzLjY2OSw3Ljg1MWw4MS41ODUtNDcuMTAzICAgICBDMjIxLjAyOSwxNjIuMDgyLDIyMS4wNDUsMTU1LjAyNiwyMTMuNTU1LDE1MC42NTJ6IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iYWN0aXZlLXBhdGgiIHN0eWxlPSJmaWxsOiM0RDRFNEUiIGRhdGEtb2xkX2NvbG9yPSIjNEQ0RDREIj48L3BhdGg+CgkJPC9nPgoJPC9nPgo8L2c+PC9nPiA8L3N2Zz4=);
            }

            &.vjs-selected {
              img {
                opacity: 1;
              }
            }

            .vjs-playlist-duration {
              padding: 2px 5px 2px;
              background-color: rgba(var(--primary-color), 0.6);
              font-size: 0.8em;
              font-weight: 700;
              border-radius: 2px;
            }

            .vjs-playlist-now-playing-text {
              margin: 0.5rem !important;
              padding: 1px 5px 3px !important;
              background-color: rgba(var(--secondary-color), 0.6);
              font-size: 0.8em;
              font-weight: 700;
              border-radius: 2px;
            }

            .vjs-playlist-title-container {
              padding: 0.4rem 0.6rem;
              text-shadow: none !important;
              background-color: rgba(0, 0, 0, 0.6);

              .vjs-up-next-text {
                display: none !important;
              }

              .vjs-playlist-name {
                padding: 0 0 4px 2px;
                font-size: 0.9em;
              }
            }
          }
        }
      }
    }

    .main-page-container {
      min-height: 100vh;
      background-color: #fafafa;

      .video-information {
        padding: 1em;
        background-color: #eceff1;
        border-radius: 0.1em;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        margin-bottom: 2em;

        .info-wrapper {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: start;
          justify-content: space-between;
          width: 100%;

          h1.title {
            text-align: left;
            margin-top: 0;
            font-size: 1.5em;

            @include hasColorTitre(var(--color-title));
            margin-bottom: 0.8em;
            border-bottom: 2px solid var(--secondary-color);
            display: inline-block;
          }

          .meta-info-container {
            display: flex;
            font-size: 0.8em;
            color: #7b7b7b;
            justify-content: center;
            align-items: center;
            margin-bottom: 0.2em;
          }
        }

        .description-wrapper {
          h2.subtitle {
            color: var(--primary-color);
            font-size: 1.2em;
            margin-top: 1em;
          }

          .description span {
            white-space: pre-line;
            width: 100%;
          }
        }
      }
    }
  }

  @media all and (-ms-high-contrast: none) {
    #embed_video /deep/ .vjs-big-play-button {
      transition: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/EmbedVideo.vue